const articlePath = path => {
  path = path + '/';
  return path.startsWith('/articles') ? path : ('/articles/' + path).replaceAll('//', '/');
}

module.exports = articlePath;
